import styled from 'styled-components';

export const ToggleWrapper = styled.div`
  label {
    width: 200px;
  }
  input {
    margin: 0 4px;
    max-width: 37px;
  }
  span {
    margin: 0 4px;
  }
`;
